import { Injectable } from '@angular/core';

import { EventType, GTMService } from '@personal-area/global/gtm';

@Injectable({
  providedIn: 'root',
})
export class DepositBonusTrackingService {
  constructor(private _gtmService: GTMService) {}

  public getVerifiedTapped(): void {
    this._gtmService.event(EventType.GetVerifiedTapped, {
      context: 'rewards_hub',
      object: 'get_verified',
      action: 'tapped',
    });
  }

  public depositBonusDialogViewed(): void {
    this._gtmService.event(EventType.DepositBonusDialogViewed, {
      context: 'rewards_hub',
      object: 'deposit_bonus_dialog',
      action: 'viewed',
    });
  }

  public depositFromBonusTapped(): void {
    this._gtmService.event(EventType.DepositFromBonusTapped, {
      context: 'rewards_hub',
      object: 'deposit_from_bonus',
      action: 'tapped',
    });
  }

  public bannerDepositBonusViewed(): void {
    this._gtmService.event(EventType.BannerDepositBonusViewed, {
      context: 'deposit_bonus',
      object: 'banner_deposit_bonus',
      action: 'viewed',
    });
  }

  public alertDepositBonusViewed(): void {
    this._gtmService.event(EventType.AlertDepositBonusViewed, {
      context: 'deposit_bonus',
      object: 'alert_deposit_bonus',
      action: 'viewed',
    });
  }

  public expiredDepositBonusViewed(dateExpiration: string): void {
    this._gtmService.event(EventType.ExpiredDepositBonusViewed, {
      context: 'deposit_bonus',
      object: 'expired_deposit_bonus',
      action: 'viewed',
      dateExpiration
    });
  }

  public termsDepositBonusViewed(): void {
    this._gtmService.event(EventType.TermsDepositBonusViewed, {
      context: 'deposit_bonus',
      object: 'terms_deposit_bonus',
      action: 'viewed',
    });
  }
}
